<template>
    <div class="w-full flex flex-wrap">
        <div class="mt-2 flex flex-col w-full">
            <div class="w-full shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                <table class="table-default" v-if="levels && levels.length > 0">
                    <thead>
                        <tr>
                            <th scope="col" class="hidden md:table-cell">{{$t('shared.pyramid_auction.levels.table_columns.level')}}</th>
                            <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.price_drop')}}</th>
                            <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.fixed_time')}}</th>
                            <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.price')}}</th>
                            <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.qty')}}</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-200 bg-white">
                        <tr v-for="(level, index) in levels"
                            :key="level.id"
                            :class="{
                                'bg-gray-50': level.phase % 2 === 1,
                                'price-drop': level.price_drop === 1 || index === 0
                            }">
                            <td class="hidden md:table-cell">{{ level.sequence }}</td>
                            <td><icon v-if="level.price_drop === 1" name="badge-check" class="h-6 w-6"/></td>
                            <td>{{ level.date_start | formatTime($t('locale.formatTimeTwelveHours'), tz.auctionTimeZone(), tz.code()) }}</td>
                            <td>{{ level.price | toCurrency }}</td>
                            <td>{{ level.quantity }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="!levels || levels.length < 1" class="m-3">{{$t('shared.pyramid_auction.no_levels')}}</div>
            </div>
        </div>
    </div>
</template>

<script>

import { Link } from '@inertiajs/vue2';
import Icon from '@/Shared/Icon';
import PageHeadline from "@/Shared/PageHeadline";
import TimeZoneService from "../../Services/TimeZoneService";

export default {
    components: {
        Link,
        Icon,
        PageHeadline
    },
    props: {
        levels: Array
    },
    computed: {
        tz() {
            return TimeZoneService;
        }
    }
}
</script>
